import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import { CreateReferral } from '../../pages/CreateReferral';
import { Referrals } from '../../pages/Referrals';
import { ThemeProvider } from 'emotion-theming';
import * as theme from '../../theme';
import { Layout } from '../Layout';
import { SWRConfigWithFetcher } from '../SWRConfigWithFetcher';
import { Global } from '@emotion/core';
import { UserContext } from '../../contexts/UserContext';

import type { ConfigInterface } from 'swr';
import { Services } from '../../pages/Services';
import { TrackSession } from '../../pages/Services/TrackSession';

import { useTrainingUserSession } from '../../hooks/useTrainingUserSession';
import features from '../../features';
import { BeaconManager } from '../BeaconManager/BeaconManager';

const App: React.FC<{ swrConfig?: ConfigInterface }> = ({ swrConfig }) => {
  const { user, setUser, logout } = useTrainingUserSession();
  const enabledFeatures = features();

  UserContext.displayName = 'UserContext';
  return (
    <SWRConfigWithFetcher config={swrConfig ? swrConfig : undefined}>
      <Router>
        <BeaconManager />
        <ThemeProvider theme={theme}>
          <Global styles={theme => theme.globalStyles} />
          <UserContext.Provider value={{ user, setUser, logout }}>
            <Switch>
              <Route exact path="/">
                <Layout>
                  {enabledFeatures.referral ? <Referrals /> : <Services />}
                </Layout>
              </Route>
              <Route path="/create-referral">
                <Layout>
                  <CreateReferral />
                </Layout>
              </Route>

              <Route exact path="/services">
                <Layout>
                  <Services />
                </Layout>
              </Route>
              <Route path="/services/track">
                <TrackSession />
              </Route>
            </Switch>
          </UserContext.Provider>
        </ThemeProvider>
      </Router>
    </SWRConfigWithFetcher>
  );
};

export default App;
